import {
  CREATE_THRESHOLD_REQUEST,
  CREATE_THRESHOLD_SUCCESS,
  CREATE_THRESHOLD_FAILURE,
  GET_ELEMENT_TYPES_REQUEST,
  GET_ELEMENT_TYPES_SUCCESS,
  GET_ELEMENT_TYPES_FAILURE,
  DELETE_THRESHOLD_FAILURE,
  DELETE_THRESHOLD_REQUEST,
  DELETE_THRESHOLD_SUCCESS,
  EDIT_THRESHOLD_REQUEST,
  EDIT_THRESHOLD_SUCCESS,
  EDIT_THRESHOLD_FAILURE,
} from './types/NotificationServiceActionTypes';

export function createThresholdRequestActionCreator(payload) {
  return {
    type: CREATE_THRESHOLD_REQUEST,
    payload,
  };
}

export function createThresholdSuccessActionCreator(payload) {
  return {
    type: CREATE_THRESHOLD_SUCCESS,
    payload,
  };
}

export function createThresholdFailureActionCreator(payload) {
  return {
    type: CREATE_THRESHOLD_FAILURE,
    payload,
  };
}

export function deleteThresholdRequestActionCreator(payload) {
  return {
    type: DELETE_THRESHOLD_REQUEST,
    payload,
  };
}

export function deleteThresholdSuccessActionCreator(data) {
  return {
    type: DELETE_THRESHOLD_SUCCESS,
    payload: data,
  };
}

export function deleteThresholdFailureActionCreator(error) {
  return {
    type: DELETE_THRESHOLD_FAILURE,
    payload: error,
    error: true,
  };
}

export function editThresholdRequestActionCreator(payload) {
  return {
    type: EDIT_THRESHOLD_REQUEST,
    payload,
  };
}

export function editThresholdSuccessActionCreator(data) {
  return {
    type: EDIT_THRESHOLD_SUCCESS,
    payload: data,
  };
}

export function editThresholdFailureActionCreator(error, data) {
  return {
    type: EDIT_THRESHOLD_FAILURE,
    payload: error,
    error: true,
    data,
  };
}

export function getElementTypesRequestActionCreator(payload) {
  return {
    type: GET_ELEMENT_TYPES_REQUEST,
    payload,
  };
}

export function getElementTypesSuccessActionCreator(payload) {
  return {
    type: GET_ELEMENT_TYPES_SUCCESS,
    payload,
  };
}

export function getElementTypesFailureActionCreator(payload) {
  return {
    type: GET_ELEMENT_TYPES_FAILURE,
    payload,
  };
}
